module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAQlBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8fa6fSFtdq20ulgns7z+Pv////n8PhUl8udxOHO4fB4rdZsptLC2uxuEF/SAAAAB3RSTlMAYL8AIM/vi50ITwAAAPBJREFUeF7t2DcOxDAQA0BJDlRwvPD/r57dGrBIwNud+IBpuGzWnfEBDxJ8d8R1XT/gYYb+hPoRjzP2BzTAIEPnPEziXbCBgoNRGnSXBi2X/DHUoAY1qEExLXJSDUJcVWeNVQjTrDnzxFp7a9CHt5YVJyutFe4Urf4Xc74gkHgEKYoQtmp186ZPZCLFyxAyKUyGsN85OwgkHkEBgcTqEhSI73eNMnTdLy+MQ3iTpcoQMilehlB4YRy67vcLBeJHkKIO1fY7b3gGYSLFyxAyKUyGzv3usIBQCiwgngY1yOzJYvb2sXpEmb3GLJ91Ryzehz+XgaUTnSybMgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/2b07.png
// module id = 1419
// module chunks = 0